import { TFunction } from 'i18next';

/**
 * formatCurrency formatter
 *
 * @param _        translation function
 * @param currency to format
 *
 * @returns        string the formatted string
 */
export function formatCurrency(_: TFunction, currency?: string) {
  switch (currency) {
    case 'eur':
      return `€`;
    case 'usd':
      return `$`;
    case 'gbp':
      return `£`;
    case 'cad':
      return `$`;
    default:
      return '??';
  }
}

/**
 * formatPaymentStatus formatter
 *
 * @param t             translation function
 * @param paymentStatus to format
 *
 * @returns             string the formatted string
 */
export function formatPaymentStatus(t: TFunction, paymentStatus: string) {
  switch (paymentStatus) {
    case 'paid':
      return t('Paid');
    case 'unpaid':
      return t('Unpaid');
    case 'inprogress':
      return t('In progress');
    default:
      return paymentStatus;
  }
}
